import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/change-password',
    name: 'ChangePasswordPage',
    component: () => import('@/modules/changePassword/views/ChangePasswordPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
